import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import { datadogRum } from '@datadog/browser-rum'
import '@crossfit/ui/dist/style.css'
import 'styles/main.css'
import App from 'components/App'
import { version } from '../package.json'
import AppContainer from 'containers/App'
import Providers from 'contexts'

const PUBLIC_PATH = import.meta.env.VITE_PUBLIC_PATH
const DD_APPLICATION_ID = import.meta.env.VITE_DD_APPLICATION_ID
const DD_CLIENT_TOKEN = import.meta.env.VITE_DD_CLIENT_TOKEN
const DD_ENV = import.meta.env.VITE_DD_ENV

if (DD_APPLICATION_ID && DD_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: DD_APPLICATION_ID,
    clientToken: DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'affiliate-toolkit',
    env: DD_ENV,
    version: version,
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: false,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [/https:\/\/.*\.crossfit\.com/],
  })
}

declare global {
  interface Window {
    Cypress: unknown
    needsToTrackScrollDepth: boolean
    needsToIdentify: boolean
  }
}

async function startMockServer() {
  if (window.Cypress) {
    await import('./mocks/browser').then(({ worker }) => {
      worker.start({
        serviceWorker: {
          url: '/tools/mockServiceWorker.js',
        },
      })
    })
  }
  return Promise.resolve()
}

startMockServer().then(() => {
  ReactDOM.render(
    <Router basename={PUBLIC_PATH || '/'}>
      <Providers>
        <AppContainer>
          <App />
        </AppContainer>
      </Providers>
    </Router>,
    document.getElementById('app'),
  )
})
